import { getBaseURL } from '@/features/navigation/utils/url-helpers';
import GoogleSchema from '@/components/google-schema';
import { getPDPBreadcrumb } from './_utils/get-pdp-breadcrumb';
import usePDPData from './_utils/use-pdp-data';
import { PLPPages } from '../(plp)/types';
import { PUBLIC_DOMAIN_URL } from '../_constants/urls';
function Schemas() {
  const {
    data
  } = usePDPData();
  const {
    breadcrumbBrandCategory,
    breadcrumb,
    brand
  } = data || {};
  const {
    breadcrumbPath,
    breadcrumbTitle
  } = getPDPBreadcrumb(breadcrumb || [], breadcrumbBrandCategory || null, brand || null);
  const getImageUrls = () => [...(data?.images?.map(image => `${image.imageUrl}?w=320`) || []), `${data?.mainImageUrl}?w=320`];
  const productSchema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: data?.pageH1 || `${data?.nameFa} ${data?.brand?.nameFa}`,
    image: getImageUrls(),
    description: data?.descriptionMeta || `خرید اینترنتی ${data?.pageH1} با بهترین قیمت و ضمانت بازگشت از فروشگاه آنلاین خانومی`,
    brand: {
      '@type': 'Brand',
      name: data?.brand?.nameFa
    },
    offers: {
      '@type': 'Offer',
      url: '',
      priceCurrency: 'IRR',
      price: (data?.salesPrice || 0) * 10
    }
  };
  const populatedItems = data?.breadcrumb?.map(({
    nameFa
  }, index) => {
    return {
      title: nameFa,
      url: `/${getBaseURL({
        page: PLPPages.Categories,
        basicMetas: {
          breadcrumb: data.breadcrumb?.slice(0, index + 1)
        }
      })}`
    };
  });
  const PDPBreadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: data?.brand?.nameFa,
      item: `${PUBLIC_DOMAIN_URL}/${PLPPages.Brands}/${data?.brand?.slug}`
    }, {
      '@type': 'ListItem',
      position: 2,
      name: breadcrumbTitle,
      item: `${PUBLIC_DOMAIN_URL}${breadcrumbPath}`
    }, {
      '@type': 'ListItem',
      position: 3,
      name: data?.pageH1
    }]
  };
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [populatedItems?.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.title,
      item: `${PUBLIC_DOMAIN_URL}${item.url}`
    })), {
      '@type': 'ListItem',
      position: (populatedItems?.length || 0) + 1,
      name: data?.pageH1
    }]
  };
  const MultipleBreadcrumbSchema = [breadcrumbSchema, PDPBreadcrumbSchema];
  return <>
            <GoogleSchema schema={MultipleBreadcrumbSchema} data-sentry-element="GoogleSchema" data-sentry-source-file="schemas.tsx" />
            <GoogleSchema schema={productSchema} data-sentry-element="GoogleSchema" data-sentry-source-file="schemas.tsx" />
        </>;
}
export default Schemas;